import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/entreprise/Chauffeur-pour-entreprise.png";

const business: ChauffeurPage = {
  slug: "business",
  title: "Corporate chauffeur – Business VTC",
  subtitle: "Recurring solutions for companies and teams in Cannes.",
  keywords: ["corporate chauffeur", "business vtc"],
  hero: {
    title: "Chauffeur for business",
    subtitle: "Travel for teams, clients and partners.",
    keywords: ["corporate chauffeur", "business vtc"],
    imageSrc: heroImage.src,
    imageAlt: "Chauffeur for business",
    badges: ["SLA & reliability", "Clear invoicing", "Dedicated support"],
  },
  benefits: {
    heading: "Strengths for professionals",
    items: [
      {
        title: "SLA & reliability",
        description: "Service commitments and reporting.",
      },
      {
        title: "Clear invoicing",
        description: "Flat rates and tailored terms.",
      },
      {
        title: "Dedicated support",
        description: "Fast reply from a single point of contact.",
      },
    ],
  },
  services: {
    heading: "Corporate services",
    services: [
      {
        title: "Hourly hire",
        text: "Chauffeurs for committees & executives in Cannes.",
      },
      {
        title: "Team shuttles",
        text: "Regular, recurring travel (Cannes, Sophia, Antibes).",
      },
    ],
  },
  locations: {
    heading: "Coverage",
    items: [{ name: "French Riviera" }, { name: "Provence" }],
  },
  generic: {
    heading: "Corporate mobility, simplified",
    subheading: "A single partner in Cannes for your recurring travel.",
    paragraphs: [
      "Dedicated chauffeurs on hourly hire, reporting and cost steering on a monthly or event basis.",
      "Smooth coordination for teams, clients and executives on the Riviera with a stable service framework.",
      "The corporate set-up standardises the quality of pick-up across all your sensitive trips.",
    ],
    bullets: ["SLA & tracking", "Consolidated invoices", "Priority support"],
  },
  process: {
    heading: "Setting up a corporate account",
    steps: [
      "Qualify your recurring needs and priorities.",
      "Define the service framework (SLA, hours, coverage).",
      "Activate the booking and invoicing routines.",
      "Tracking and adjustments based on your real usage.",
    ],
  },
  faq: [
    {
      q: "Can we centralise invoicing for several employees?",
      a: "Yes, we offer consolidated management with a summary of trips and cost items.",
    },
    {
      q: "Can service rules be defined per profile?",
      a: "Yes, we can adapt the terms by team, executives or external guests.",
    },
    {
      q: "Is the service compatible with urgent requests?",
      a: "Yes, dedicated support handles urgent needs quickly, subject to availability.",
    },
  ],
  relatedLinks: [
    {
      label: "Become a partner (concierges & hotels)",
      href: "/en/chauffeur/partners",
    },
    {
      label: "Chauffeur for corporate events",
      href: "/en/chauffeur/events",
    },
    {
      label: "Book a chauffeur on the Riviera",
      href: "/en/chauffeur/french-riviera",
    },
    {
      label: "Private chauffeur in Sophia Antipolis",
      href: "/en/chauffeur/sophia-antipolis",
    },
  ],
  cta: {
    title: "Open a corporate account",
    text: "Let's talk about your recurring needs and constraints.",
    primaryHref: "/contact",
    primaryLabel: "Sales contact",
  },
  seo: {
    title: "Corporate chauffeur – Business & recurring car service",
    description:
      "Car service solutions for companies in Cannes: accounts, team shuttles, executives.",
    canonical: "/en/chauffeur/business",
  },
};

export default business;
